export const getHeaders = (token: string) => ({
    headers: {
        Authorization: "Bearer " + token,
    },
});